import React from 'react'
import { FormattedMessage } from 'react-intl'
import ScrollableAnchor, { configureAnchors } from 'react-scrollable-anchor'
import { NavHashLink as NavLink } from 'react-router-hash-link'
import logoOpenHome from '../assets/logo/logotipo-footer.svg'
import logoUE from '../assets/img/logoUE.png'
import { injectIntl } from 'react-intl'
class Footer extends React.Component {
    render() {
        return (
            <footer className="footer">
                <div className="container">
                    <div className="footer__item item_1">
                        <img src={logoOpenHome} className="footer__item__logo" alt="" />
                    </div>
                    <div className="footer__item item_2">
                        <img src={logoUE} className="footer__item__logo" alt="" />
                    </div>
                    <div className="footer__item item_3">
                        <h5>
                            <strong>Enlaces</strong>
                        </h5>
                        <span>
                            <NavLink
                                to={`${this.props.intl.formatMessage({ id: '_ROUTE_HOME' })}#section__info`}
                                scroll={el =>
                                    el.scrollIntoView({
                                        behavior: 'smooth',
                                        block: 'start',
                                        inline: 'start'
                                    })
                                }
                            >
                                <FormattedMessage id="inicio" defaultMessage="Inicio" />
                            </NavLink>
                        </span>
                        <br />
                        <span>
                            <NavLink
                                to={`${this.props.intl.formatMessage({ id: '_ROUTE_HOME' })}#section__distribuidor`}
                                scroll={el =>
                                    el.scrollIntoView({
                                        behavior: 'smooth',
                                        block: 'start',
                                        inline: 'start'
                                    })
                                }
                            >
                                <FormattedMessage id="contacto" defaultMessage="Contacto" />
                            </NavLink>
                        </span>
                        {/* <br />
                        <span>
                            <NavLink smooth to={`${this.props.intl.formatMessage({ id: '_ROUTE_HOME' })}#section__distribuidor`}>
                                <FormattedMessage id="empleo" defaultMessage="Empleo" />
                            </NavLink>
                        </span> */}
                    </div>
                    <div className="footer__item item_4">
                        <h5>
                            <strong>Contacto</strong>
                        </h5>
                        <span>C/Costa Balear, nº24, Portal 1, 3ºA</span>
                        <br />
                        <span>Almería, España, 04009</span>
                        <br />
                        <span>
                            <a href="tel:950 08 90 50">950 08 90 50</a> - <a href="tel:687 79 39 52">687 79 39 52</a>
                        </span>
                        <br />
                        <span>
                            <a href="mailto:info@openhome.io">info@openhome.io</a>
                        </span>
                    </div>
                </div>
            </footer>
        )
    }
}

export default injectIntl(Footer)



// WEBPACK FOOTER //
// ./src/components/Footer.js